import { ApiWithToken } from "../axios-instance";

export const userService = {
  get: async () =>
    ApiWithToken.get("api/authentication/user/"),
  put: async (data: any) =>
    ApiWithToken.put("api/authentication/user/", data),
};
